import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import Edititemmodal from "./edititemmodal";
import iqd_rounding from "../../utils/iqd_rounding";
import money_rounding from "../../utils/money_rounding";

const Itemlist = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [item_id, setitem_id] = useState();
  const [item_name, setitem_name] = useState();
  const [item_price, setitem_price] = useState();
  const [item_barcode, setitem_barcode] = useState();
  const [item_min_notification, setitem_min_notification] = useState();
  const [item_min_sell_price, setitem_min_sell_price] = useState();
  const [company_id, setcompany_id] = useState();
  const [category_id, setcategory_id] = useState();
  const [show, setshow] = useState(false);

  return (
    <div>
      <Edititemmodal
        item_id={item_id}
        item_name={item_name}
        setitem_name={setitem_name}
        item_price={item_price}
        setitem_price={setitem_price}
        item_barcode={item_barcode}
        setitem_barcode={setitem_barcode}
        item_min_notification={item_min_notification}
        setitem_min_notification={setitem_min_notification}
        item_min_sell_price={item_min_sell_price}
        setitem_min_sell_price={setitem_min_sell_price}
        company_id={company_id}
        setcompany_id={setcompany_id}
        category_id={category_id}
        setcategory_id={setcategory_id}
        show={show}
        setshow={setshow}
      />
      {/* Table */}
      <table className="w-full">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-100">
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              ناوی کاڵا
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              باڕکۆد
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              نرخ
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              بڕی ماوە
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              بەرواری بەسەرچون
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              کاتیگۆری کاڵا
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              گۆڕانکاری
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-50">
          {initState.item.map((lis) => (
            <tr
              key={lis.item_id}
              className="hover:bg-slate-50 transition-colors duration-100"
            >
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right ">
                  {lis.item_name}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right ">
                  {lis.item_barcode}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right ">
                  {numberbeautify(money_rounding(lis.item_price))}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right ">
                  {lis.item_qty}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right ">
                  {lis.item_exp_date}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right ">
                  {lis.category_name}
              </td>
              <td className="px-6 py-4 text-right">

                <button
                  className={
                    "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                  }
                  onClick={() => {
                    setitem_id(lis.item_id);
                    setitem_name(lis.item_name);
                    setitem_price(lis.item_price);
                    setitem_barcode(lis.item_barcode);
                    setitem_min_notification(lis.item_min_notification);
                    setitem_min_sell_price(lis.item_min_sell_price);
                    setcompany_id(lis.company_id);
                    setcategory_id(lis.category_id);
                    setshow(true);
                  }}
                >
                  گۆڕانکاری
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Itemlist;
